<template>
  <b-container
    fluid="md"
    class="square-payment-payment-general-error"
  >
    <b-row>
      <b-col>
        <div class="title pb-4">
          <span class="icon-container">
            <font-awesome-icon
              icon="triangle-exclamation"
              size="2x"
              class="icon"
              fixed-width
              color="red"
            />
          </span>
          <span class="h3 pr-4">
            General error
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="error-type">
          Type: General error
        </div>
        <div class="error-type">
          Reason: {{ reason }}
        </div>

        <div class="error-message">
          Message: {{ errMessage }}
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'payment-rules-fact-error',
  props: {
    error: {
      type: [Object, Error],
      required: true
    }
  },
  computed: {
    reason: function() {
      return this.error.name
    },
    errMessage: function() {
      return this.error.message
    }
  }
}
</script>

<style>

</style>
